import { resolveLink as o, resolveImage as s } from "../../../helpers/index.js";
const i = (r) => r && r.length > 0 ? r.map((e) => ({
  name: e.properties?.header || "",
  title: e.properties?.title || "",
  src: e.properties?.image?.[0] && s(e.properties?.image),
  link: e.route?.path ? o({ route: e.route }) : void 0
})) : [], a = (r) => r && r.length > 0 ? r.map((e) => ({
  startTime: new Date(e.content.properties?.startTime),
  endTime: e.content.properties?.endTime ? new Date(e.content.properties?.endTime) : void 0,
  title: e.content.properties?.header,
  description: e.content.properties?.remark,
  link: e.content.properties?.link ? o(e.content.properties?.link) : void 0,
  languageAnnotation: e.content.properties?.language,
  online: e.content.properties?.online,
  contributors: e.content.properties?.speakers ? i(e.content.properties?.speakers) : []
})) : [], c = (r) => ({
  days: [
    {
      date: new Date(r.properties?.date),
      entries: a(
        r.properties?.programEntries?.items ? r.properties?.programEntries?.items : []
      )
    }
  ],
  downloadLink: r.properties?.link && o(r.properties?.link)
}), l = (r, e) => r.reduce((n, t, p) => p === 0 ? t : p === r.length - 1 ? `${n} ${e} ${t}` : `${n}, ${t}`, ""), g = (r) => {
  const e = r.getHours().toString().padStart(2, "0"), n = r.getMinutes().toString().padStart(2, "0");
  return `${e}:${n}`;
};
export {
  g as formatTime,
  l as serialCommaSentence,
  c as singleTrackProgramDeliveryApiParser
};
